import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Formats a number as Kenyan Shillings, e.g. 18500 -> "KES 18,500". */
export function formatKes(amount: number | string): string {
  const value = typeof amount === "string" ? parseFloat(amount) : amount;
  return `KES ${value.toLocaleString("en-KE", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

/** Converts a Category enum value like "POWER_TOOLS" into "Power Tools". */
export function formatCategoryLabel(category: string): string {
  return category
    .split("_")
    .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
    .join(" ");
}
